export interface TestMessage {
  message: string
}

export function decodeTestMessage(data: Uint8Array): TestMessage {
  const message = new TextDecoder().decode(data)

  return {
    message,
  }
}
